import styled from "@emotion/styled";

export const StyledPopoverContent = styled.div`
  display: flex;
  gap: 5px;

  .reaction-span {
    font-size: 24px;
    cursor: pointer;
    border-radius: 50%;
    height: 40px;
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition:
      transform 0.2s ease,
      box-shadow 0.2s ease,
      background-color 0.2s ease;

    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    &.selected {
      background-color: rgba(0, 0, 0, 0.1);
      transform: scale(1.1);
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    }
  }
`;
